var _defs, _path, _g, _rect, _g2, _rect2, _rect3, _rect4, _polygon, _polygon2, _polygon3, _ellipse, _path2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _polygon4, _polygon5, _ellipse8, _path3, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _circle2, _circle3, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 378.44 325.79",
    width: 0,
    height: 0,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 191.25,
    y1: 158.09,
    x2: 192.05,
    y2: 476.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 153.7,
    y1: 76.33,
    x2: 494.53,
    y2: 317.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -794.43,
    y1: 3080.09,
    x2: -800.45,
    y2: 2521.18,
    gradientTransform: "matrix(1, -0.09, -0.09, -1, 1238.09, 3066.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 153.04,
    y1: 153.04,
    x2: 254.24,
    y2: 445.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -830.51,
    y1: 2995.42,
    x2: -626.59,
    y2: 2515.18,
    gradientTransform: "matrix(1, -0.09, -0.09, -1, 1233.14, 3058.69)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -380.13,
    y1: 3379.83,
    x2: -386.16,
    y2: 2820.37,
    gradientTransform: "matrix(0.93, -0.36, -0.36, -0.93, 1664.1, 3080.23)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -416.66,
    y1: 3296.14,
    x2: -210.79,
    y2: 2811.34,
    gradientTransform: "matrix(0.93, -0.36, -0.36, -0.93, 1654.58, 3079.28)",
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M391.34,217.29a116.22,116.22,0,0,0-17.6-34.53c-12.51-16.82-29.29-30.71-38.33-49.62C305.93,71.5,265.78,12,190.49,11.94c-69.93,0-91.45,53.7-95.57,61.59-10,19.15-8.87,42.08-14.89,62.83-8.39,28.89-29.91,51.69-47.56,76-6.26,8.64-12.23,17.94-14,28.46-1.08,6.44-.53,13,.07,19.54,1.47,15.91,9,25.15,15.77,38.63a70.55,70.55,0,0,0,30.32,30.85c23.44,12.09,57.17,7.69,82.37,3.28,30.55-5.34,59.59-17.61,91.13-16.22a332.78,332.78,0,0,1,56.48,7.47c12.56,2.78,21.88,8.92,35.15,7.11,27.43-3.75,51.77-25.94,61.14-51.43C398.27,260,397.75,237.82,391.34,217.29Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#01BF97",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.64,302.29l-.16.16c-9.72,9.85,13.91,15.85,20,16.86,15.06,2.49,33.52-2.26,48.76-3.23q52-3.27,104.25-2.12c16.88.38,34.57.94,49.7-6.57,2-1,4.07-2.34,4.49-4.49.79-4-4.53-7.17-3.84-11.14,3.45-3.51,9.05-3.18,13.88-4.13s10.09-5.62,7.82-10c-.84-1.63-2.53-2.62-4.16-3.47-18.05-9.44-35.92-12.74-56.28-14.06C224.59,257.17,181,262.38,136,268c-26.65,3.33-53.12-2-78.91,4.51-6.57,1.67-6.87,11-.44,13.11a113.05,113.05,0,0,0,24.73,5.06A6.85,6.85,0,0,1,85.64,302.29Z",
    transform: "translate(-17.84 -11.94)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.43,
    y: 180.26,
    width: 37.94,
    height: 33.05,
    fill: "#01BF97"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.07,
    y: 154.55,
    width: 37.94,
    height: 58.75,
    fill: "#01BF97"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.71,
    y: 127.42,
    width: 37.94,
    height: 85.89,
    fill: "#01BF97"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192.35,
    y: 101,
    width: 37.94,
    height: 112.3,
    fill: "#01BF97"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 229.99,
    y: 74.38,
    width: 37.94,
    height: 138.93,
    fill: "#01BF97"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 229.99,
    y: 74.38,
    width: 37.94,
    height: 138.93,
    fill: "url(#linear-gradient-2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "85.7 210.14 283.56 193.73 292.34 286.63 94.47 303.04 85.7 210.14",
    fill: "#01BF97"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.33 220.78 273.08 206.29 279.64 275.68 104.89 290.17 98.33 220.78",
    fill: "url(#linear-gradient-3)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.89 299.85 279.65 240.7 261.49 195.56 266.11 195.18 248.91 152.87 223.91 159.72 212.07 168.42 105.94 301.28 132.89 299.85",
    fill: "url(#linear-gradient-4)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.25,
    cy: 259.82,
    rx: 26.64,
    ry: 27.66,
    transform: "translate(-88.14 432.62) rotate(-86.23)",
    fill: "#01BF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.24,280.45l-.26-4.92a14.92,14.92,0,0,1-7.78-1.82l1-3.28a13.81,13.81,0,0,0,7.29,1.75c3.58-.16,5.86-2.23,5.72-5s-2.18-4.21-6-5.51c-5.22-1.7-8.49-3.78-8.71-8-.22-4,2.57-7.17,7.15-8.1l-.26-4.91,3.11-.15.24,4.68a14.14,14.14,0,0,1,6.6,1.4l-1.05,3.3a12.45,12.45,0,0,0-6.4-1.37c-3.86.17-5.19,2.46-5.09,4.39.14,2.5,2.06,3.67,6.47,5.22,5.29,1.79,8,4.19,8.24,8.48.2,3.81-2.37,7.51-7.47,8.56l.26,5Z",
    transform: "translate(-17.84 -11.94)",
    fill: "url(#linear-gradient-5)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.81,
    cy: 265.22,
    rx: 6.81,
    ry: 7.08,
    transform: "translate(-144.39 383.34) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.85,
    cy: 256.18,
    rx: 6.81,
    ry: 7.08,
    transform: "matrix(0.07, -1, 1, 0.07, -33.5, 483.7)",
    fill: "#01BF97"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.93,
    cy: 218.22,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(36.22 482.24) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.49,
    cy: 287.59,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-26.87 553.61) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.17,
    cy: 232.71,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-141.52 321.4) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.74,
    cy: 302.08,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-204.6 392.77) rotate(-86.23)",
    fill: "#01BF97"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.03 218.39 240.45 150.51 275.22 237.7 89.8 305.58 55.03 218.39",
    fill: "#01BF97"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.18 225.32 233.94 165.37 259.92 230.49 96.16 290.44 70.18 225.32",
    fill: "url(#linear-gradient-6)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.4,
    cy: 240.71,
    rx: 26.64,
    ry: 27.66,
    transform: "translate(-91.36 390.97) rotate(-86.23)",
    fill: "#01BF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.27,260.85l-1.64-4.66a15.05,15.05,0,0,1-8,.29l.05-3.44a13.85,13.85,0,0,0,7.5-.22c3.4-1.1,5-3.7,4.08-6.31S182,243,178,242.76c-5.5-.26-9.23-1.41-10.64-5.39-1.34-3.8.44-7.58,4.58-9.69L170.28,223l2.95-1,1.56,4.44a14.11,14.11,0,0,1,6.74-.38l-.08,3.45a12.52,12.52,0,0,0-6.54.37c-3.66,1.18-4.29,3.73-3.64,5.56.84,2.38,3,3,7.69,3.33,5.59.33,8.88,1.92,10.32,6,1.28,3.62-.14,7.86-4.75,10.22l1.68,4.76Z",
    transform: "translate(-17.84 -11.94)",
    fill: "url(#linear-gradient-7)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.63,
    cy: 260.24,
    rx: 6.81,
    ry: 7.08,
    transform: "translate(-158.28 358.56) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.81,
    cy: 222.84,
    rx: 6.81,
    ry: 7.08,
    transform: "matrix(0.07, -1, 1, 0.07, -25.49, 425.57)",
    fill: "#01BF97"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.79,
    cy: 177.3,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(40.48 404.96) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.77,
    cy: 242.4,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-0.2 491.7) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.02,
    cy: 237.26,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-172.35 297.56) rotate(-86.23)",
    fill: "#01BF97"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114,
    cy: 302.35,
    rx: 11.17,
    ry: 11.6,
    transform: "translate(-213.04 384.3) rotate(-86.23)",
    fill: "#01BF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.05,160.71a.77.77,0,0,0-.14.21,5.25,5.25,0,0,0,0,2.4,26.38,26.38,0,0,0,1.25,5.1,1,1,0,0,0,.23.42.66.66,0,0,0,.87-.07,1.84,1.84,0,0,0,.42-.85,23.77,23.77,0,0,0,.5-2.8c.17-1.2,1.79-1.88,2.72-2.42a.45.45,0,0,0,.19-.17c0-.1.56,1.17.53,1.07a14.43,14.43,0,0,0-.85-2.12c0-.06-.6-1.51-.65-1.54s-.21,0-.3.06a3.48,3.48,0,0,1-2.48.19A2.46,2.46,0,0,0,131.05,160.71Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.35,159.85a3.12,3.12,0,0,0-2.06.21,1.05,1.05,0,0,0-.5.43,1.26,1.26,0,0,0-.08.61A27.71,27.71,0,0,0,131,169a2.82,2.82,0,0,0,.45.92,1,1,0,0,0,.91.4A1.25,1.25,0,0,0,133,170a3.23,3.23,0,0,0,.25-4.62,4.09,4.09,0,0,1-.62-.7,2.45,2.45,0,0,1-.28-.84,14.5,14.5,0,0,1-.27-2.27A15.85,15.85,0,0,1,132.35,159.85Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#473f47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.21,146.79a30.14,30.14,0,0,1-2,4.66c-1.78,3-4.57,5.32-7.38,7.43-1.53,1.15-3.07,2.26-4.65,3.34a16.72,16.72,0,0,1-2.56,1.13.49.49,0,0,1-.28.07.44.44,0,0,1-.2-.13c-1.22-1.09-2.08-2.5-.74-3.59a23.11,23.11,0,0,0,3.69-3.52c2.16-2.72,4-5.83,6.86-7.87a1.49,1.49,0,0,0,.78-1.77q-.42-6-.43-12.07a7.36,7.36,0,0,1,.5-3.24c1.23-2.55,5.68-2.87,8.08-2.64a3,3,0,0,1,1.59.47c2.75,2.17,1.52,4.88.54,7.52Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#473f47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.45,114.55l0,0c.52.46,8.43,3,9.45,2.72,1.21-.31,4.36-9.16,5.3-12.39a.7.7,0,0,0,0-.55.52.52,0,0,0-.18-.18c-1.94-1.25-3.1,1.69-3.57,3a24.58,24.58,0,0,1-3,5.7c-2,.16-6.81-1.77-7.39-1.79a1.69,1.69,0,0,0-1.53.87C165.08,112.89,165.75,113.9,166.45,114.55Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.31,109.69c.24.16.48.31.73.45a.47.47,0,0,1,.25.23.46.46,0,0,1,0,.26l-.47,2.14a7,7,0,0,1-1,2.69c-.29.39-2.41-1-2.71-1.23a8.84,8.84,0,0,1-2.27-2.17,3.93,3.93,0,0,1-.65-1.23,4.94,4.94,0,0,1,.47-3.18c.83-1.61,2.21-.82,3.27.17A15.47,15.47,0,0,0,167.31,109.69Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#01BF97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.09,165.14a.81.81,0,0,0,.16.16,5,5,0,0,0,2.2.48,24.24,24.24,0,0,0,4.89-.19,1,1,0,0,0,.44-.13.61.61,0,0,0,.09-.8,1.66,1.66,0,0,0-.7-.55,21.87,21.87,0,0,0-2.47-1c-.37-.14-.69-.2-.69-.67a1.75,1.75,0,0,1,.14-.64l.26-.76c.09-.27.18-.6,0-.81a.77.77,0,0,0-.44-.19,10.59,10.59,0,0,0-2.25-.21.31.31,0,0,0-.21.05.31.31,0,0,0-.09.14C155.89,161.25,154.1,163.87,155.09,165.14Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.63,125.75s-4,5.6.11,10.58c2.87,3.46,7.16,5.81,11.11,7.79.69.35,1.51.64,2.18,1.06,1.31.81.5,1.51-.19,2.61-1.73,2.8-3.49,5.57-5.26,8.34a11.44,11.44,0,0,0-2.06,4.69l4.48,1.35a85.85,85.85,0,0,1,8.19-11.67c1.32-1.58,3-3.51,2.79-5.71a10.48,10.48,0,0,0-2.57-5.44L159,129.61Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#473f47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.1,99c.14.42.54.74.6,1.19s-.39,1-.68,1.43c-.4.63-.5,1.42-.9,2.06a.81.81,0,0,1-.32.34,1.4,1.4,0,0,1-.41.06,5.61,5.61,0,0,1-1.57-.26.46.46,0,0,0-.3-.07.5.5,0,0,0-.2.23,8.57,8.57,0,0,0-.83,4c0,.44,0,1-.36,1.23a.79.79,0,0,1-.45.11c-1,0-1.83-.92-2.33-1.84a11.85,11.85,0,0,1-1-2.6,2.22,2.22,0,0,1-.09-.81,2.49,2.49,0,0,1,.33-.91,17.45,17.45,0,0,0,1.25-3.19,14,14,0,0,1,1.47-4.11,2.28,2.28,0,0,1,1.11-.92A3,3,0,0,1,165,95a4.2,4.2,0,0,1,2.67,1.59C167.84,96.91,167.93,98.48,168.1,99Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.84,130.34a6.26,6.26,0,0,1-2.69-.14,13.47,13.47,0,0,0-3.91-.22,13.71,13.71,0,0,0-2.27.75c-1.46.43-4.11.07-4.08-1.86.11-6,2.43-11.71,5-17.13,1.09-2.33,2.34-4.75,4.52-6.1a6.29,6.29,0,0,1,9.13,2.79,12.8,12.8,0,0,1,1,4.42c.17,1.9.2,4-.86,5.55a16,16,0,0,1-1.65,1.85,11.07,11.07,0,0,0-2.76,5.55C158.94,127.4,160.3,129.84,157.84,130.34Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#01BF97"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.61,95.92c-.72,1.15-1.93.68-2.92,1.15s-1,1.91-2,2.57c-.42.31-.94.53-1.19,1a2.5,2.5,0,0,0-.17,1.28,17.8,17.8,0,0,1,0,1.93,2.82,2.82,0,0,1-.5,1.61c-.73.85-2.07.62-3.19.73-2.19.22-2.93,2.29-4.38,3.69-.71.69-1.5,1.29-2.15,2a14.33,14.33,0,0,0-2.31,4,14.6,14.6,0,0,1-1.71,3.22,4.61,4.61,0,0,1-3,1.9,4.14,4.14,0,0,1-3.14-1.09,5.16,5.16,0,0,1-1.41-5.42,1.39,1.39,0,0,0,.13-1,1.47,1.47,0,0,0-.39-.47,4,4,0,0,1,0-5.57c.79-.75,2.68-1.46,2.78-2.69s-1-2.43-.53-3.84a3.89,3.89,0,0,1,.69-1.18,5.94,5.94,0,0,1,2.24-2,8.3,8.3,0,0,1,2.82-.46c3.08-.22,6.3-1.16,8.33-3.5a15.38,15.38,0,0,1,1.51-1.71,6.35,6.35,0,0,1,2.14-1.08,8.54,8.54,0,0,1,5.81-.09,4.73,4.73,0,0,1,2.71,3.08A2.29,2.29,0,0,1,167.61,95.92Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fc682d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.26,101.06c-.39,0-1,0-1.35-.11-.12.24.46,1.13.59,1.24a.33.33,0,0,0,.44,0,.44.44,0,0,0,.11-.25l.21-.89",
    transform: "translate(-17.84 -11.94)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.36,
    cy: 86.78,
    r: 0.36,
    fill: "#231f20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.74,102a1.64,1.64,0,0,0-1.37,1,1.88,1.88,0,0,0,.74,2,4.72,4.72,0,0,0,2.11.77.77.77,0,0,0,.65-.09.79.79,0,0,0,.19-.39,4,4,0,0,0,.22-1.6A2.42,2.42,0,0,0,178.74,102Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.54,163.78a2.89,2.89,0,0,0-.19,1.92,1,1,0,0,0,.3.54,1.26,1.26,0,0,0,.54.2,26.29,26.29,0,0,0,7.51.3,2.66,2.66,0,0,0,.93-.24,1,1,0,0,0,.54-.76,1.15,1.15,0,0,0-.18-.62A3,3,0,0,0,159.8,164a4.74,4.74,0,0,1-.75.44,2.52,2.52,0,0,1-.82.09,11.82,11.82,0,0,1-2.14-.18A13.75,13.75,0,0,1,154.54,163.78Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#473f47"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150,109.25c-.86,0-1-1.38-1.69-.84a42.73,42.73,0,0,0-5.57,5.18c-1.18,1.36-5.09,8.14-5.89,9.23a14.11,14.11,0,0,0-2.76,5,2.34,2.34,0,0,0,.06,1.61c1,2,4.23-1.83,4.81-2.77.44.32,1.1.6,1.46.19.5-.56-.26-1.4-.5-1.92a3.06,3.06,0,0,1-.06-2.17,7.27,7.27,0,0,1,1.4-2.28,30.06,30.06,0,0,1,9.72-7.74c.54-.27,1.15-.59,1.31-1.17a1.41,1.41,0,0,0-.07-.86A2.29,2.29,0,0,0,150,109.25Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#fcab9a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159,110.05s-10,4.75-10.58,5.26-3.56-5.53-3.56-5.53,9.86-5.82,13-5.46S162.12,108.07,159,110.05Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#01BF97"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.76,82.11v-.64",
    transform: "translate(-17.84 -11.94)",
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.96,
    cy: 57.62,
    r: 16.75,
    fill: "#f8c244"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.96,
    cy: 57.62,
    r: 14.28,
    fill: "#e8a825"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.85,78.59l-.59-2.22a6.48,6.48,0,0,1-3.6-.07l.13-1.6a6,6,0,0,0,3.38.1c1.57-.41,2.38-1.59,2.05-2.83s-1.37-1.73-3.17-2c-2.47-.28-4.12-.92-4.62-2.82a3.72,3.72,0,0,1,2.37-4.41l-.59-2.21,1.36-.36.56,2.12a6.18,6.18,0,0,1,3.05,0L268,64a5.38,5.38,0,0,0-2.95,0c-1.69.45-2.05,1.62-1.82,2.5.3,1.14,1.26,1.49,3.37,1.77,2.51.32,3.95,1.16,4.47,3.1A4,4,0,0,1,268.63,76l.61,2.28Z",
    transform: "translate(-17.84 -11.94)",
    fill: "#f8c244"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg-1.8c099e3294c68ea2bb657eb0fd97ee0a.svg";
export { ForwardRef as ReactComponent };